<div class="ion-no-padding padt10 ion-padding-horizontal padb10 eventContent">
  <div class="scrollx no-scroll ion-no-padding ion-no-margin">
    <div class="scroll-item" *ngFor="let item of hotelList">
      <ion-card
        class="grey-border border-r8 ion-no-margin padb5 marb10 marr10"
        (click)="navigateToHotelSearch(item)"
      >
        <img
          class="card-img"
          [src]="item?.images?.[0] || imagePlaceholder"
          (error)="handleImageError($event)"
        />

        <ion-card-header class="ion-padding-horizontal ion-no-padding">
          <ion-item class="ion-bg-white" lines="none">
            <ion-label>
              <div class="ion-text-wrap">
                <h5 class="fs-2 font600 primary-text-color line-2-clip hotel-name">
                  {{ item?.hotelName }}
                </h5>
                <p class="tertiary-text-color" *ngIf="item?.hotelRating">
                  <ion-icon class="hotel-rating" name="star"></ion-icon>
                  {{ item?.hotelRating }}
                </p>
              </div>
            </ion-label>
          </ion-item>
        </ion-card-header>
      </ion-card>
    </div>
  </div>
</div>
